import { EntityFields } from './entity';
import {
  FieldOption,
  FieldOptionDataResponse,
  FieldOptions,
  FieldOptionsRead,
  FieldOptionsResponse,
  FieldOptionsWithData,
  FieldOptionsWriteRequest,
} from './field-options';
import { KeyAndDisplay } from './key-and-display';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response, WriteResponse } from './response';
import {
  SecurityAccess,
  SecurityAccessFieldOptions,
  SecurityAccessFieldOptionsResponse,
} from './security-access';
import { SecurityStatus } from './security-status';

export enum WorkflowFields {
  Name = 'Name',
  Description = 'Description',
  IsSequential = 'IsSequential',
  HasStages = 'HasStages',
  Category = 'Category',
  CreationDate = 'CreationDate',
  Creator = 'Creator',
  LastModifyDate = 'LastModifyDate',
  ModifiedBy = 'ModifiedBy',
  DisplayValue = 'DisplayValue',
  Tag = 'TAG',
}

export interface Workflow {
  [EntityFields.Key]: string | null;
  [WorkflowFields.Name]?: string;
  [WorkflowFields.Description]?: string;
  [WorkflowFields.IsSequential]?: boolean;
  [WorkflowFields.HasStages]?: boolean;
  [WorkflowFields.Category]?: KeyAndDisplay[];
  [EntityFields.SecStatus]?: SecurityStatus;
  [EntityFields.SecAccess]?: SecurityAccess;
}

export interface WorkflowFieldOptions {
  Category: FieldOption;
}

export interface WorkflowReadRequest extends Request {
  Workflow: ReadRequest<Workflow>;
}

export interface WorkflowReadResponse extends Response {
  Workflow: DataResponse<Workflow>;
}

export interface WorkflowFieldOptionsRequest extends Request {
  Workflow: FieldOptions<WorkflowFieldOptions> & SecurityAccessFieldOptions;
}

export interface WorkflowFieldOptionsResponse extends Response {
  Workflow: FieldOptionsResponse<WorkflowFieldOptions> &
    SecurityAccessFieldOptionsResponse;
}

export interface WorkflowWriteRequest extends Request {
  Workflow: WriteRequest<Workflow>;
}

export interface WorkflowWriteResponse extends Response {
  Workflow: WriteResponse<Workflow>;
}

export interface WorkflowFieldOptionRequest extends Request {
  Workflow: FieldOptionsWithData<WorkflowFieldOptions, Workflow>;
}

export interface WorkflowFieldOptionResponse extends Response {
  Workflow: FieldOptionsResponse<WorkflowFieldOptions>;
}

export interface WorkflowFieldOptionReadRequest extends Request {
  Workflow: FieldOptionsRead<WorkflowFieldOptions>;
}

export interface WorkflowFieldOptionReadResponse extends Response {
  Workflow: FieldOptionDataResponse<WorkflowFieldOptions>;
}

export interface WorkflowFieldOptionWriteRequest extends Request {
  Workflow: FieldOptionsWriteRequest<WorkflowFieldOptions>;
}
